import { skeleton } from '../../skeleton';

type Props = {
  loading?: boolean;
};

const Facebook = ({ loading }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 266.9 266.9"
    className={skeleton.className('line', loading)}
  >
    <path
      fill="#3C5A99"
      d="M248 262.3c8 0 14.3-6.4 14.3-14.2V18.8c0-7.8-6.4-14.2-14.2-14.2H18.8C11 4.6 4.6 11 4.6 18.8v229.3c0 7.8 6.4 14.2 14.2 14.2h229.3z"
    />
    <path
      fill="#FFF"
      d="M182.4 262.3v-99.8H216l5-38.9h-38.5V98.8c0-11.3 3.1-19 19.3-19h20.6V45c-3.6-.4-15.8-1.5-30-1.5-29.7 0-50 18.1-50 51.4v28.7h-33.6v38.9h33.5v99.8h40.2z"
    />
  </svg>
);

export default Facebook;
